import React, { useEffect } from "react";
import { useOktaAuth } from "@okta/okta-react";
import { toRelativeUrl } from "@okta/okta-auth-js";
import { Outlet } from "react-router-dom";
import Loading from "../utils/Loader";

export const RequiredAuth = () => {
  const { oktaAuth, authState } = useOktaAuth();

  useEffect(() => {
    // Check if authState is defined
    if (!authState) {
      return;
    }

    // If not authenticated, redirect to the login page
    if (!authState?.isAuthenticated) {
      const originalUri = toRelativeUrl(
        window.location.href,
        window.location.origin
      );
      oktaAuth.setOriginalUri(originalUri);
      oktaAuth.signInWithRedirect(); // Redirect to Okta for login
    }
  }, [oktaAuth, !!authState, authState?.isAuthenticated]);

  // While checking authentication, show loading
  if (!authState || !authState?.isAuthenticated) {
    return <Loading />;
  }

  // If authenticated, render the child components
  return <Outlet />;
};
